<script setup lang="ts">
import type { Component } from 'vue';
import { computed } from 'vue';
import SalesforceForm from './SalesforceForm.vue';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    salesforceForm?: any;
  };
  config: {
    innerComponent?: Component;
  };
}>();

const data = computed(() => ({
  productInterest: props.block?.salesforceForm?.productInterest,
  fieldsTexts: props.block?.salesforceForm?.fieldsTexts,
  platformOptions: props.block?.salesforceForm?.platformOptions,
  blockerInputTexts: props.block?.salesforceForm?.blockerInputTexts,
  submitButtonText: props.block?.salesforceForm?.submitButtonText,
}));

const FormComponent = computed(() => props.config?.innerComponent ?? SalesforceForm);
</script>

<template>
  <div v-if="block?.salesforceForm" class="wrapper wrapper--content">
    <component :is="FormComponent" v-bind="data" />
  </div>
</template>
